import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        padding: 2,
        '& svg': {
            color: theme.colors.icon.default,
        },
    },
}));
//# sourceMappingURL=DatePickerClearIcon.styles.js.map